import { Component, Vue, Prop } from 'vue-property-decorator';
import { CountryData, GroupCountry } from '@/models/groups/country';
import { groupsApi } from '@/providers/apis/groups/groups';
import { GroupHierarchy } from '@/models/groups/hierarchy';
import { getNetworkDefaultURL } from '@/utils/utils';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
    components: {
    },
  })
  export default class NetworkHierarchySelection extends Vue {

    @Prop()
    private groupCountry!: CountryData;
    @Prop()
    private groupHierarchies!: any[];

    private hierarchies!: GroupHierarchy[];

    private countryId!: number;

    private isLoading: boolean = false;

    private isShowTenants: boolean = false;

    private activeHierarchy: GroupHierarchy | any = null;

    private activeTenants: {id?: string; name?: string, isActive?: boolean; } = {};

    private created() {
      this.countryId = parseInt(this.$route.params.id, 10);
      // this.loadGroupCountries();
    }

    private onSelectHierarch(hierarchy: GroupHierarchy) {

      this.activeHierarchy = hierarchy;
      const selectedHierarcy = this.groupHierarchies.find((groupHierarchy) => groupHierarchy.id === hierarchy.id);
      appConfigService.setUserGroupAccessLevel(selectedHierarcy.levels);
      this.isShowTenants = true;
    }

    private onSelectTenant(tenant: {id: string; name: string, isActive: boolean; }) {
      // tenant.isActive = true;
      // this.activeTenants = [];
      this.activeTenants = tenant;
    }

    private onShowReports() {
      this.$access.setGroupHierarchyTenants(JSON.stringify(this.activeTenants));
      const params = {
        groupType: 'country',
        name: this.groupCountry.name,
      };
      const query = {
        groupId: this.groupCountry.id,
        hierarchyId: this.activeHierarchy.id,
      };
      this.$router.push(getNetworkDefaultURL(params, query, true));
      // this.$router.push({path: `/network/country/${this.groupCountry.name}`, query})
    }

    private loadGroupCountries() {
      this.isLoading = true;
      groupsApi.fetchGroupCountries().then((groupCountry: GroupCountry) => {
        const countryData  = groupCountry.data.find((country: CountryData) => country.id === this.countryId);
        if (countryData) {
          this.groupCountry = countryData;
          this.hierarchies = countryData.hierarchies;
        }
        this.isLoading = false;
      });
    }

    private onGoBack() {
      this.$emit('onGoBack');
    }
}
